/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {createRef, useCallback, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Modal, Tabs, Tab} from "react-bootstrap";
import {withTranslation} from "react-i18next";
import {apiService} from "../../service/Apiservice";
import {sendEtrackerClickEvent} from "../../util/utilFkt";
import DropdownGroup from "../../components/Dropdown/DropdownGroup";
import {BUY_NOW_ASSET_DOMAIN} from "../../constant";
import {BYNDER_PARAMS} from "../../constant";

const BuyButton = props => {

  /** Import Countries Name */
  const { countries } = require(`../../translations/countries.json`);

  const [toggleDisplayModal, setToggleDisplayModal] = useState(false);
  const [productBuyOptions, setProductBuyOptions] = useState(null);
  const [productBuySupplierOptions, setProductBuySupplierOptions] = useState(null);
  const [packagingImages, setPackagingImages] = useState(null);
  const [countryFilterWholesaler, setCountryFilterWholesaler] = useState({name: "", label: ""});
  const [countryFilterGarage, setCountryFilterGarage] = useState({name: "", label: ""});
  const [countryFilterOnline, setCountryFilterOnline] = useState({name: "", label: ""});
  const [key, setKey] = useState('online');
  const [packageFilter, setPackageFilter] = useState({name: "", label: ""});
  const ref = createRef();
  const {selectedProductDetails, configLang, t} = props;

  const fetchProductBuyOptions = useCallback(async () => {
    try {
      const {ean} = selectedProductDetails;
      const response = await apiService.fetchBuyNow(ean, configLang, false);
      return response[0];
    } catch (e) {
      // fail silently for now
      return null;
    }
  }, [selectedProductDetails, configLang]);

  useEffect(() => {
    if(!productBuyOptions && !productBuySupplierOptions) {
      
      fetchProductBuyOptions().then(response => {
        if (response !== null) {
          /**
           * We expect response.shops to be an array of object
           * this is the only key we need from the response.
           */
          if (Array.isArray(response.shops)) {
            setProductBuyOptions(response.shops);
            setCountryFilterOnline("");
            setPackageFilter(""); 
          }

          if (Array.isArray(response.suppliers)) {
            setProductBuySupplierOptions(response.suppliers);
            setCountryFilterWholesaler("");
            setCountryFilterGarage("");
          }

          if (Array.isArray(response.packagingImages)) {
            setPackagingImages(response.packagingImages);
          }
        }
      }).catch(error => {
        console.error(error);
      });
    }

    //* Everytime change of country in online tab will reset the package filter
    setPackageFilter("");

  }, [fetchProductBuyOptions, productBuyOptions, productBuySupplierOptions, countryFilterOnline]);

  const handleOnClick = (event) => {
    event.preventDefault();
    sendEtrackerClickEvent("Buy Button", "click");
    toggleModal();
  }

  const toggleModal = () => setToggleDisplayModal(prevState => !prevState);

  const getDropDownFields = (productBuyOptions) => {
    if (Array.isArray(productBuyOptions)) {
      const unsortedPackage = Object.values(
        productBuyOptions
          .filter(productBuyOption => /*productBuyOption.active &&*/ productBuyOption.packagingDescr !== "UNV" && countryFilterOnline.name === productBuyOption.countryId)
          .reduce((a, c) => {
          const {packageType,packagingPieces} = c;
          a[packageType+'_'+packagingPieces] = {
            name: packageType,
            label: `${packageType} (${t("buyNow.containing")} ${packagingPieces.split(".")[0]} ${t("buyNow.pieces")})`,
          };
          return a;
        }, {}))

        return [...unsortedPackage].sort((a, b) =>
          a.name.localeCompare(b.name, 'de', { sensitivity: 'base' })
        );
    }
  }

  const getDropDownCountryFields = (productBuyOptions) => {
    if (Array.isArray(productBuyOptions)) {
      const unsortedPackage = Object.values(
        productBuyOptions.reduce((a, c) => {
          const {countryId} = c;
          a[countryId] = {
            name: countryId,
            label: countries[countryId],
          };
          return a;
        }, {}))

        return [...unsortedPackage].sort((a, b) =>
          a.label.localeCompare(b.label, 'en', { sensitivity: 'base' })
        );
    }
  }

  const getDropDownCountryFieldsForGarage = (productBuySupplierOptions) => {
    if (Array.isArray(productBuySupplierOptions)) {
      const unsortedPackage = Object.values(
        productBuySupplierOptions
        .filter(productBuySupplierOption => productBuySupplierOption.shopFlag == 'Garage')
        .reduce((a, c) => {
          const {countryId} = c;
          a[countryId] = {
            name: countryId,
            label: countries[countryId],
          };
          return a;
        }, {}))

        return [...unsortedPackage].sort((a, b) =>
          a.label.localeCompare(b.label, 'en', { sensitivity: 'base' })
        );
    }
  }

  const getDropDownCountryFieldsForWholesaler = (productBuySupplierOptions) => {
    if (Array.isArray(productBuySupplierOptions)) {
      const unsortedPackage = Object.values(
        productBuySupplierOptions
        .filter(productBuySupplierOption => productBuySupplierOption.shopFlag == 'Wholesaler')
        .reduce((a, c) => {
          const {countryId} = c;
          a[countryId] = {
            name: countryId,
            label: countries[countryId],
          };
          return a;
        }, {}))

        return [...unsortedPackage].sort((a, b) =>
          a.label.localeCompare(b.label, 'en', { sensitivity: 'base' })
        );
    }
  }

  if (!productBuyOptions && !productBuySupplierOptions) {
    return <></>;
  }
  
  const dropDownFieldItems = getDropDownFields(productBuyOptions);
  const dropDownCountryFieldItems = getDropDownCountryFields(productBuyOptions);
  const dropDownCountryFieldItemsForGarage = getDropDownCountryFieldsForGarage(productBuySupplierOptions);
  const dropDownCountryFieldItemsForWholesaler = getDropDownCountryFieldsForWholesaler(productBuySupplierOptions);
  const displayLabelAndDropDownDown = (dropDownFieldItems != null && dropDownFieldItems.length > 0)? true : false;
  const displayCountryLabelAndDropDownDown = (dropDownCountryFieldItems != null && dropDownCountryFieldItems.length >= 1)?  true : false;
  const displayCountryLabelForGarage = (dropDownCountryFieldItemsForGarage != null && dropDownCountryFieldItemsForGarage.length >= 1)?  true : false;
  const displayCountryLabelForWholesaler = (dropDownCountryFieldItemsForWholesaler != null && dropDownCountryFieldItemsForWholesaler.length >= 1)?  true : false;

  

  return (
    <>
      <a
        style={{cursor: 'pointer'}}
        onClick={handleOnClick}
        className="with-icon-left link-btn orange-action-hover-btn btn-hover-fix but-now-btn"
        title={t("product.buynowlabel")}>
        <svg className="icon-cart-white"/>
        {t("product.buynowlabel")}
      </a>
      <Modal
        show={toggleDisplayModal}
        onHide={toggleModal}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedProductDetails.linecard_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
            {productBuyOptions &&
              <Tab eventKey="online" title={t('buyNow.Online')}>
                    {displayCountryLabelAndDropDownDown &&
                      <DropdownGroup
                        dropdownFields={[{
                          name: 'buyNowCountryFilter',
                          titleId: t('buyNow.ModalBodyCountryTitle'),
                          selectId: t('buyNow.selectCountry'),
                          currentItem: countryFilterOnline,
                          items: dropDownCountryFieldItems
                        }]}
                        dropdownRefs={[ref]}
                        onChangeDropdown={(index, selected) => {
                          setCountryFilterOnline(selected);
                        }}
                      />
                    }
                    {displayLabelAndDropDownDown &&
                    <div className="BuyButton_PackageLayout">
                      <DropdownGroup
                        dropdownFields={[{
                          name: 'buyNowFilter',
                          titleId: t('buyNow.ModalBodyTitle'),
                          selectId: t('buyNow.selectPackage'),
                          currentItem: packageFilter,
                          items: dropDownFieldItems
                        }]}
                        dropdownRefs={[ref]}
                        onChangeDropdown={(index, selected) => {
                          setPackageFilter(selected);
                        }}
                      />
                      {packagingImages != null && 
                        packagingImages
                          .filter(packagingImage => packageFilter.name === packagingImage.packageType && countryFilterOnline.name === packagingImage.countryId)
                          .slice(0, 1)
                          .map( (packageImage) => {
                            return (
                              <div className="package-image">
                                <img className="eh" width="45" height="45" alt="Package Image Preview" src={packageImage.packagingImage} />
                                <img className="eh" src="https://look.ams-osram.com/transform/051499fe-04dd-4477-b216-30f7dcb735d8/How-to-use-ONiX-Icons" alt="Zoom Available" style={{position: "absolute", top: "-6px", right: "-6px", width: "22px", height: "22px", background: "white", borderRadius: "50%", padding: "3px", boxShadow: "0 0 3px rgba(0, 0, 0, 0.3)"}} />
                                <div className="previewBox">
                                <img id="zoomedPreviewImage" alt="Zoomed Package Image" src={packageImage.packagingImage} />
                                </div>
                              </div>)}
                        )
                      }
                    </div>
                    }
                    <div className="BuyButton__layout-grid">
                      {
                        productBuyOptions
                        .filter(productBuyOption => productBuyOption.active && packageFilter.name === productBuyOption.packageType && countryFilterOnline.name === productBuyOption.countryId)
                        .map((shop) => {
                          const {productId, url, domain,bynder_link} = shop;
                          return (
                            <div key={`${domain}-${productId}`} className="shop">
                              <div className="BuyButton__container">
                                <div className="BuyButton__layout-flex">
                                  <img
                                    className="BuyButton__image"
                                    src={`${bynder_link}?${BYNDER_PARAMS}`}
                                    alt={`${domain}-${productId}`}
                                  />
                                </div>
                              </div>
                              <div className="BuyButton__layout-flex">
                                <a
                                  className="link-btn orange-action-hover-btn btn-hover-fix BuyButton__anchor"
                                  href={url} target="_blank" rel="noopener noreferrer">
                                    {t('buyNow.ModalBuyNowButton')}
                                </a>
                              </div>
                            </div>
                          )
                        })
                      }
                      {
                        productBuyOptions
                        .filter(productBuyOption => !productBuyOption.active && packageFilter.name === productBuyOption.packageType && countryFilterOnline.name === productBuyOption.countryId)
                        .map((shop) => {
                          const {productId, url, domain,bynder_link} = shop;
                          return (
                            <div key={`${domain}-${productId}`} className="not-available shop">
                              <div className="BuyButton__container">
                                <div className="BuyButton__layout-flex">
                                  <img
                                    className="BuyButton__image"
                                    src={`${bynder_link}?${BYNDER_PARAMS}`}
                                    alt={`${domain}-${productId}`}
                                  />
                                </div>
                              </div>
                              <div className="BuyButton__layout-flex">
                                <a
                                  className="link-btn orange-action-hover-btn btn-hover-fix BuyButton__anchor"
                                  href={url} target="_blank" rel="noopener noreferrer">
                                    {t('buyNow.NotAvailableButton')}
                                </a>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                    <div>
                    {
                      (configLang == 'de_DE' || countryFilterOnline.name == 'DE') &&
                        <div className="disclaimer">{t('buyNow.disclaimer')}</div>
                    }
                  </div>
              </Tab>
            }
            {(productBuySupplierOptions && displayCountryLabelForWholesaler) &&
              <Tab eventKey="wholesaler" title={t('buyNow.Wholesaler')}>
                  {displayCountryLabelForWholesaler &&
                    <DropdownGroup
                      dropdownFields={[{
                        name: 'buyNowCountryFilter',
                        titleId: t('buyNow.ModalBodyCountryTitle'),
                        selectId: t('buyNow.selectCountry'),
                        currentItem: countryFilterWholesaler,
                        items: dropDownCountryFieldItemsForWholesaler
                      }]}
                      dropdownRefs={[ref]}
                      onChangeDropdown={(index, selected) => {
                        setCountryFilterWholesaler(selected);
                      }}
                    />
                  }
                  <div className="BuyButton__layout-grid">
                      {productBuySupplierOptions
                        .filter(productBuySupplierOption => productBuySupplierOption.shopFlag === 'Wholesaler' && countryFilterWholesaler.name === productBuySupplierOption.countryId)
                        .map((suppliers) => {
                          const {url,bynder_link} = suppliers;
                          return (
                            <div /*key={`${domain}-${productId}`}*/>
                              <div className="BuyButton__container">
                                <div className="BuyButton__layout-flex">
                                  <img
                                    className="BuyButton__image"
                                    src={`${bynder_link}?${BYNDER_PARAMS}`}
                                    //alt={`${domain}-${productId}`}
                                  />
                                </div>
                              </div>
                              <div className="BuyButton__layout-flex">
                                <a
                                  className="link-btn orange-action-hover-btn btn-hover-fix BuyButton__anchor"
                                  href={url} target="_blank" rel="noopener noreferrer">
                                  {t('buyNow.ModalBuyNowWholsalerButton')}
                                </a>
                              </div>
                            </div>
                          )
                        })
                      }
                  </div>
              </Tab>
            }
            {(productBuySupplierOptions && displayCountryLabelForGarage) &&
              <Tab eventKey="garage" title={t('buyNow.Garage')}>
                {displayCountryLabelForGarage &&
                  <DropdownGroup
                    dropdownFields={[{
                      name: 'buyNowCountryFilter',
                      titleId: t('buyNow.ModalBodyCountryTitle'),
                      selectId: t('buyNow.selectCountry'),
                      currentItem: countryFilterGarage,
                      items: dropDownCountryFieldItemsForGarage
                    }]}
                    dropdownRefs={[ref]}
                    onChangeDropdown={(index, selected) => {
                      setCountryFilterGarage(selected);
                    }}
                  />
                }
                <div className="BuyButton__layout-grid">
                    {productBuySupplierOptions
                      .filter(productBuySupplierOption => productBuySupplierOption.shopFlag === 'Garage' && countryFilterGarage.name === productBuySupplierOption.countryId)
                      .map((suppliers) => {
                        const {url,bynder_link} = suppliers;
                        return (
                          <div /*key={`${domain}-${productId}`}*/>
                            <div className="BuyButton__container">
                              <div className="BuyButton__layout-flex">
                                <img
                                  className="BuyButton__image"
                                  src={`${bynder_link}?${BYNDER_PARAMS}`}
                                  //alt={`${domain}-${productId}`}
                                />
                              </div>
                            </div>
                            <div className="BuyButton__layout-flex">
                              <a
                                className="link-btn orange-action-hover-btn btn-hover-fix BuyButton__anchor"
                                href={url} target="_blank" rel="noopener noreferrer">
                                {t('buyNow.ModalBuyNowWholsalerButton')}
                              </a>
                            </div>
                          </div>
                        )
                      })
                    }
                </div>
              </Tab>
            }
          </Tabs>
          
        </Modal.Body>
      </Modal>
    </>
  );
};

BuyButton.propTypes = {
  selectedProductDetails: PropTypes.shape({
    color_code: PropTypes.string,
    ean: PropTypes.string,
    ece: PropTypes.string,
    keyvisual_id: PropTypes.string,
    linecard_id: PropTypes.string,
    linecard_name: PropTypes.string,
    pillar_id: PropTypes.string,
    prio: PropTypes.string,
    usp: PropTypes.string
  }).isRequired,
  configLang: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(BuyButton);